export var raSearchLanguageFrench = {
    'ra-search': {
        recent: 'Récent',
        result: '1 résultat |||| %{smart_count} résultats',
    },
};
export default raSearchLanguageFrench;
